import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ImgDropzone from '../../../../../Components/ImgDropzone/ImgDropzone';
import { CloseIcon } from '../../../../../bombiix-icon';

function UploadImageModal({ childRef, imageModal, element, getImage, handleImageUpload }) {
  const { t } = useTranslation('common');

  return (
    <Modal className="common-custom-modal modal-large" show={imageModal.isOpen}>
      <Modal.Header>
        <Modal.Title className="f-24">{t('CUSTOM_MODULES.LIBRARY.TABLE.UPLOAD_IMAGE.UPLOAD_IMAGE')}</Modal.Title>
        <CloseIcon size={24} className="cursor-pointer text-dark text-decoration-none" onClick={() => handleImageUpload('close')} />
      </Modal.Header>

      <Modal.Body>
        <div className="modal-body">
          <ImgDropzone
            ref={childRef}
            onSubmit={handleImageUpload}
            acceptedFileExtenstion=".jpeg,.png,.jpg"
            title={imageModal.controlKey}
            image={element?.key === 'Company_Stamp' ? getImage(element?.companyLogo) : getImage(element?.digitalSignPath)}
            isEditMode={false}
            cropSize="FREE"
            fromCustomModule
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default UploadImageModal;
